import React from 'react';
import { Cell, Container, Row } from './styles';

type Props = {
  rows?: number;
};

const TableSkeleton: React.FC<Props> = ({ rows = 7 }) => (
  <Container role="status" aria-busy="true" aria-label="Carregando dados">
    {Array.from({ length: rows }, (_rowValue, row) => (
      <Row key={row}>
        {Array.from({ length: 4 }, (_cellValue, cell) => (
          <Cell key={cell} />
        ))}
      </Row>
    ))}
  </Container>
);

export default TableSkeleton;
